import { Modal, PrimaryButton } from '@cb/apricot-react';
import { FC } from 'react';
import { ISummary, IStatusUpdate } from 'src/types';
import { cleanMessage } from '../../../utils/string';
import { styled } from '@mui/system';

const Emphasis = styled('span')`
  font-weight: 600;
`;

interface StatusHistoryModalProps {
  isOpen?: boolean;
  onClose: VoidFunction;
  summary: ISummary | null;
}

interface StatusProps {
  update: IStatusUpdate;
  separator?: boolean;
}
export const LABEL_MAPPING: any = {
  submitted: 'Ready to Process',
  processing: 'Under Review',
  reopen: 'Waiting for user to resubmit info',
  appeal: 'Pending Appeal',
  international: 'Pending International',
  testSecurity: 'Pending Test Security',
  opsApproved: 'Vetting Approved',
  rejected: 'Rejected',
  completed: 'Completed',
  started: 'Started'
};

export const StatusUpdate = ({ update, separator }: StatusProps) => {
  const statusLabel = LABEL_MAPPING[update.status] || 'N/A';
  const containerStyles: any = { padding: '5px 0px 0px 5px', lineHeight: '1.4em', marginBottom: '10px' };
  if (separator)
    containerStyles['borderBottom'] = '1px solid #DDD';

  return <div style={containerStyles}>
    <div style={{ marginBottom: '5px' }}><span>Status:</span> <Emphasis>{statusLabel}</Emphasis></div>
    <div style={{ marginBottom: '10px' }}>
      {(update.status === 'completed' && update.aiCode) && <div style={{ marginBottom: '5px' }}><span>School Code is</span> <Emphasis>{update.aiCode}</Emphasis>.</div>}
      {(update.status === 'completed' && update.aiLevelInd) && <div style={{ marginBottom: '5px' }}><span>Approved School Level is</span> <Emphasis>{update.aiLevelInd}</Emphasis>.</div>}
      {(update.status === 'rejected') && <div style={{ marginBottom: '5px' }}><span>Appeal Eligible: </span> <Emphasis>{update.appealEligible ? 'Yes' : 'No'}</Emphasis></div>}
      {(update.status === 'reopen') && <div style={{ marginBottom: '5px' }}><span>Require Testing Plan Updates: </span> <Emphasis>{update.requireTestingPlan ? 'Yes' : 'No'}</Emphasis></div>}
    </div>

    {update.comment &&
      <div style={{ marginBottom: '10px' }}>
        {/* <div style={{ color: "#7b7b7b", marginBottom: '5px' }}>Comments</div> */}
        <div style={{ fontWeight: 500, maxWidth: '600px', backgroundColor: '#f6f6f6', borderRadius: '5px', padding: '5px 5px', whiteSpace: 'pre-line' }}>{cleanMessage(update.comment)}</div>
      </div>
    }
    <div style={{ fontSize: 11, color: '#7b7b7b', marginBottom: '10px' }}>
      <span style={{ fontStyle: 'italic' }}>{update.user || ''}</span>&nbsp;@&nbsp;{new Date(update.time).toLocaleString()}
    </div>
  </div >;
};

export const StatusHistoryModal: FC<StatusHistoryModalProps> = ({ isOpen, onClose, summary }) => {
  const statusUpdates = summary?.statusUpdates?.slice().sort((a, b) => b.time - a.time) || [];
  return (
    // @ts-ignore
    <Modal
      title="Status History"
      actions={[
        <PrimaryButton key="close" onClick={onClose}>
          Close
        </PrimaryButton>,
      ]}
      closeButton={false}
      open={isOpen}
      onClose={onClose}
      withHeader>
      {statusUpdates.map((update) => {
        return <StatusUpdate update={update} separator={true}></StatusUpdate>;
      })}
    </Modal>
  );
};

